module.exports = __webpack_public_path__ + "assets/img/btn-view-ef9a3a40.png";